import { Group } from '@mantine/core';
import { ReactNode } from 'react';

import { Publication } from '@/module/Author/Publication/model/PublicationTypes';

import { TitleCard } from '@/core/components';

import { Source } from '@feature/utils';

interface PublicationTitleProps {
  publication: Publication;
  pre?: ReactNode;
}

export function PublicationTitle({ publication, pre }: PublicationTitleProps) {
  const { title, source } = publication;
  return (
    <TitleCard
      title={title}
      pre={
        <Group gap="3px">
          {pre}
          <Source source={source} />
        </Group>
      }
    />
  );
}
